import { BeamButton } from "../../landing-page/components/BeamButton";
import useTranslation from "../../client/hooks/useTranslation";

export default function CtaFinal() {
  const t = useTranslation();
  return (
    <section className="relative overflow-hidden px-6 py-20 lg:px-8">
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-56 w-[600px] rounded-full bg-primary/8 blur-3xl" />
      <div className="relative z-10 mx-auto max-w-3xl text-center">
        <h2 className="font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          {t.marketing.common.ctaFinalTitle}
        </h2>
        <div className="mt-8 flex justify-center">
          <BeamButton size="lg" showArrow className="px-6">
            {t.marketing.common.ctaFinalButton}
          </BeamButton>
        </div>
      </div>
    </section>
  );
}
